module.exports = __webpack_public_path__ + "static/main6-1a7a04915af21a8b0059d9aa11904128.png";